import { GetWorldCupScheduleResp } from "@usecase/world-cup/get-world-cup-schedule/get-world-cup-schedule.type";
import { Observable } from "rxjs";

export abstract class WorldCupRepository {
    abstract GetWorldCupSchedule(): Observable<GetWorldCupScheduleResp>;
}